module.exports = __webpack_public_path__ + "img/5.aea7fd0d.jpg";